import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { GomelRegionWithLoader } from './loaders';
import { getCitiesByRegion } from '../../../actions/city/thunks';
import { RegionTypes } from '../../../types/Models/City/City';

export const GomelRegion = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getCitiesByRegion(RegionTypes.GOMEL));
    }, []);

    return <GomelRegionWithLoader />;
};
